module.exports = __webpack_public_path__ + "img/arrowLeft.c1214772.svg";